import { Columns3 } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function ColumnsAnalysisIndexPage() {
  return (
    <DesignsList
      module="analysis_columns"
      description="Análisis estructural de columnas — abre uno guardado o crea uno nuevo."
      icon={<Columns3 size={24} strokeWidth={1.5} />}
    />
  );
}
